<div class="html not-front logged-in one-sidebar sidebar-first page-node page-node- page-node-158 node-type-acc-cntl-page footer-columns">

<div id="skip-link">
  <a href="#main-content" class="element-invisible element-focusable">メインコンテンツに移動</a>
</div>
<div id="page-wrapper">
  <div id="page">

    <div id="header" class="with-secondary-menu" [ngClass]="{'dev-header': env === 'dev', 'stg-header': env === 'stg'}">
      <div class="section clearfix">

        <a href="https://myfxpool.com/" title="ホーム" rel="home" id="logo">
          <img src="https://myfxpool.com/sites/default/files/mfp1.png" alt="ホーム" />
        </a>

        <div id="name-and-slogan" class="element-invisible">

          <div id="site-name" class="element-invisible">
            <strong>
              <a href="https://myfxpool.com/" title="ホーム" rel="home"><span>myfxpool.com</span></a>
            </strong>
          </div>


        </div> <!-- /#name-and-slogan -->


        <div id="main-menu" class="navigation">
          <h2 class="element-invisible">メインメニュー</h2>
          <ul id="main-menu-links" class="links clearfix">
            <li class="menu-198 first"><a href="https://myfxpool.com/">Home</a></li>
            <li class="menu-1142"><a href="https://contact.myfxpool.com/client/monthlyProfitSimple" title="">月報（損益率のみ）</a></li>
            <li class="menu-621"><a href="https://contact.myfxpool.com/client/monthlyReport">月次損益報告</a></li>
            <li class="menu-391"><a href="https://myfxpool.com/fpool23" title="">ForexPOOL</a></li>
            <li class="menu-1134"><a href="https://myfxpool.com/website" title="">当サイトについて</a></li>
            <li class="menu-355"><a href="https://myfxpool.com/services" title="We do the followings">Services</a></li>
            <li class="menu-358"><a href="https://myfxpool.com/about">About Us</a></li>
            <li class="menu-1136 active-trail last active"><a href="https://contact.myfxpool.com/" class="active-trail active">コンタクト</a>
            </li>
          </ul>
        </div> <!-- /#main-menu -->

        <div id="secondary-menu" class="navigation">
          <h2 class="element-invisible">セカンダリーメニュー</h2>
          <ul id="secondary-menu-links" class="links inline clearfix">
            <li class="env-symbol">{{env === 'prod' ? '' : '【' + env + ' 環境】'}}</li>
            <li class="menu-15 first last"><a href="https://myfxpool.com/user/logout" title="">ログアウト</a></li>
          </ul>
        </div> <!-- /#secondary-menu -->

      </div>
    </div> <!-- /.section, /#header -->



    <div id="main-wrapper" class="clearfix">
      <div id="main" class="clearfix">

        <div id="breadcrumb">
          <h2 class="element-invisible">現在地</h2>
          <div class="breadcrumb"><a href="https://myfxpool.com/">ホーム</a></div>
        </div>

        <div id="sidebar-first" class="column sidebar">
          <div class="section">
            <div class="region region-sidebar-first">
              <div id="block-menu-menu-user-menu-2" class="block block-menu">

                <h2>User Menu</h2>

                <div class="content">
                  <ul class="menu clearfix">
                    <li class="leaf"><a href="https://contact.myfxpool.com/client/monthlyProfitSimple" title="">月報（損益率のみ）</a></li>
                    <li class="leaf"><a href="https://contact.myfxpool.com/client/monthlyReport" title="">月次損益報告</a></li>
                    <li class="leaf"><a href="https://myfxpool.com/mail2509" title="">メール対応時間について</a></li>
                    <li class="last leaf"><a href="https://myfxpool.com/user/logout" title="">ログアウト</a></li>
                  </ul>
                </div>
              </div>
              <div id="block-menu-menu-forexpool" class="block block-menu">

                <h2>ForexPOOL</h2>

                <div class="content">
                  <ul class="menu clearfix">
                    <li class="first leaf"><a href="https://myfxpool.com/fpool23" title="">ForexPOOLについて</a></li>
                    <li class="leaf"><a href="https://myfxpool.com/subsc2" title="">出資の手順</a></li>
                    <li class="leaf"><a href="https://myfxpool.com/cred" title="">資金の入金に関して</a></li>
                    <li class="leaf"><a href="https://myfxpool.com/canc" title="">解約・出金の手順</a></li>
                    <li class="leaf"><a href="https://myfxpool.com/application2" title="">出資申込書・依頼書</a></li>
                    <li class="leaf"><a href="https://myfxpool.com/hcharge">成功報酬手数料について</a></li>
                    <li class="leaf"><a href="https://myfxpool.com/incenred" title="">手数料割引について</a></li>
                    <li class="last leaf"><a href="https://myfxpool.com/performance" title="">過去の運用成績</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- /.section, /#sidebar-first -->

        <div id="content" class="column">
          <div class="section">
            <router-outlet />
          </div>
        </div> <!-- /.section, /#content -->


      </div>
    </div> <!-- /#main, /#main-wrapper -->


    <div id="footer-wrapper">
      <div class="section">

        <div id="footer-columns" class="clearfix">
          <div class="region region-footer-firstcolumn">
            <div id="block-menu-menu-footer" class="block block-menu">


              <div class="content">
                <ul class="menu clearfix">
                  <li class="first last leaf"><a href="https://myfxpool.com/notes" title="Notes and Disclaimers">Notes &amp; Disclaimers</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div> <!-- /#footer-columns -->


      </div>
    </div> <!-- /.section, /#footer-wrapper -->

  </div>
</div> <!-- /#page, /#page-wrapper -->

</div>

<div class="loading-overlay" *ngIf="loadingService.isLoading$ | async">
  <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
</div>
